import { FIELD_TYPES } from "constants/template-field-type";
import HubspotContactFormFields from "segments/desktop/core-components/hubspot-contact-form/fields-config";
import AssetFieldsConfig from "components/core/asset/fields-config";

export default {
  type: FIELD_TYPES.NESTED,
  label: "Hubspot On Dark Background",
  fields: {
    ...HubspotContactFormFields,
    LeftSideContent: {
      type: FIELD_TYPES.NESTED,
      label: "Left Side Content",
      fields: {
        title: {
          type: FIELD_TYPES.TEXT,
          label: "Title"
        },
        subTitle: {
          type: FIELD_TYPES.TEXT,
          label: "Sub Title"
        },
        valuesList: {
          type: FIELD_TYPES.MULTIPLE_NESTED,
          label: "Values List",
          nestedConfig: {
            type: FIELD_TYPES.NESTED,
            fields: {
              value: {
                type: FIELD_TYPES.TEXT,
                label: "Value"
              }
            }
          }
        },
        sentenceAboveLogos: {
          type: FIELD_TYPES.TEXT,
          label: "Sentence Above Logos"
        },
        logos: {
          type: FIELD_TYPES.MULTIPLE_NESTED,
          label: "Logos",
          nestedConfig: {
            type: FIELD_TYPES.NESTED,
            fields: {
              ...AssetFieldsConfig.image.fields
            }
          }
        }
      }
    }
  }
};
